export const getDiscount = ({
  oldPrice,
  price
}: {
  oldPrice: number;
  price: number;
}) => {
  if (oldPrice !== price) {
    const percentSplitted = Math.floor(
      100 - (Number.parseInt(`${price * 100}`) / (oldPrice * 100)) * 100
    );

    return `${percentSplitted}%`;
  } else {
    return "";
  }
};
